export default {
  id: 'attendanceRecord',
  code: 'CN',
  text: {
    'Absent (without notice)': '旷课',
    'Late': '迟到',
    'Attended': '出勤',
    'Absent (with excuse)': '请假',
    'Unchecked': '无记录',
    'Make Up': '补签',
    'Teacher': '老师',
  }
}



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/Attendance/locale.js